import view from '@/mixins/view'

import { populate, sort, filter } from '@/data'

export default {
  name: 'single-industry',
  mixins: [view],
  data () {
    return {
      page: null
    }
  },
  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })
      this.preloadAssets().then(() => {
        this.ready = true
        this.parseTextBlocks()
      })
    })
  },
  methods: {
    fetchData: async function (store, params) {
      return Promise.all([
        store.getters.get(params.post_type, params.slug, true),
        store.getters.get('partner'),
        store.getters.get('post')
      ]).then(([page, partners, posts]) => {
        return { page, partners, posts }
      })
    },
    preloadAssets: async function () {
      return this.fetch(this.getCleanLink(this.getImageUrl(this.page.meta.cover.image_desktop, 'cover-desktop')))
    },
    getPage: async function () {
      await this.fetchData(this.$store, Object.assign({}, this.$attrs, this.$route.params)).then(({ page, partners, posts }) => {
        page = populate(page, posts, 'posts')
        this.page = page
        partners = sort(partners, 'title', 'asc')
        partners = filter(partners, 'industry', page.id)
        this.partners = partners
      })
    },
    parseTextBlocks () {
      if (this.page.meta.blocks) {
        for (let i = 0; i < this.page.meta.blocks.length; i++) {
          const block = this.page.meta.blocks[i]
          if (block.type !== 'text') { continue }
          let highlight = block.text.highlight
          if (!highlight) { continue }

          if (i - 1 >= 0) {
            if (this.page.meta.blocks[i - 1].type == 'text') {
              this.page.meta.blocks[i - 1].text.prevHighligth = true
            }
          }

          if (i + 1 < this.page.meta.blocks.length) {
            if (this.page.meta.blocks[i + 1].type == 'text') {
              this.page.meta.blocks[i + 1].text.postHighligth = true
            }
          }
        }
      }
    }
  }
}
